exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.plan-of-record-container{display:flex;flex-direction:column;height:100vh;width:100vw}.plan-of-record-container .main-header{height:76px;width:100%}.plan-of-record-container .plan-of-record-body{display:flex;flex-direction:row;height:100%}.plan-of-record-container .plan-of-record-body .plan-of-record-nav-container{width:254px;height:100%;background-color:#222;margin:0}.plan-of-record-container .plan-of-record-body .plan-of-record-detail-container{overflow:hidden;height:100%;width:calc(100% - 254px);background:#f2f4f6}.plan-of-record-container .plan-of-record-body .plan-of-record-detail-container .no-plan-of-record-container{width:100%;height:100vh;display:flex;align-items:center;flex-direction:column;justify-content:center}.plan-of-record-container .plan-of-record-body .plan-of-record-detail-container .no-plan-of-record-container .location-icon{height:162px;width:128px;margin-bottom:30px;margin-top:-175px}.plan-of-record-container .plan-of-record-body .plan-of-record-detail-container .no-plan-of-record-container .no-plan-of-record{text-align:center;font-family:Open Sans,sans-serif;font-weight:700;font-size:24px;color:#9b9b9b;letter-spacing:0;overflow:hidden;background-color:transparent}.plan-of-record-container .plan-of-record-body .plan-of-record-detail-container .no-plan-of-record-container .no-plan-of-record .add-button{vertical-align:middle;margin-left:3px;margin-right:3px;cursor:pointer}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/PORContainer/PORContainer.scss
// module id = 1761
// module chunks = 0